import { GraphQlClient } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getTransactionsBatch({ commit }, { filters = {} }) {
    commit('toggleLoading', true);
    const {
      search_by: search_by = 'order_number',
      search_values: search_values = [],
    } = filters;

    const params = {
      search_by,
      search_values,
    };

    return GraphQlClient.query(`
      query (
        $search_by: String,
        $search_values: [String],
      ) {
        order_batch (
          search_by: $search_by,
          search_values: $search_values,
        ) {
          items {
            order_number,
            marketplace_order_number,
            volumes {
              invoice {
                number
                serie
                key
              }
            }
            shipped_date,
            estimated_delivery_client,
            estimated_delivery_transp,
            shipment_order_volume_state_localized,
            table_status_localized,
            table_status_lp_localized,
            end_customer {
              name,
              last_name,
              address {
                state,
                city,
              }
            }
            logistic_provider {
              delivery_method {
                name,
                service_type,
              }
            }
          }
          total
        }
      }`, params)
      .then(({ data = {} }) => {
        const { order_batch = [] } = data;

        const {
          items = [],
          total = 0,
        } = order_batch;

        commit('toggleLoading', false);
        commit('setTransactionsBatch', items);
        commit('setTransactionsBatchTotal', total);

        return Promise.resolve(order_batch);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },

  exportTransactionsBatch({ commit }, filters) {
    commit('toggleLoadingExport', true);

    const {
      search_by: search_by = 'order_number',
      search_values: search_values = [],
    } = filters || {};

    const params = {
      search_by,
      search_values,
    };

    return GraphQlClient.mutation(`
      mutation (
        $search_by: String,
        $search_values: [String],
      ) {
        orderBatchExport (
          search_by: $search_by,
          search_values: $search_values,
        ) {
          ok
        }
      }`, params)
      .then((res) => {
        commit('toggleLoadingExport', false);
        ScToast.success('O arquivo de relatório está sendo gerado, em instantes estará disponível na seção "Meus Arquivos".');

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoadingExport', false);

        return Promise.reject(err);
      });
  },
  getShipmentOrderList({ commit }, params) {
    commit('toggleLoading', true);
    return GraphQlClient.query(`
      query {
        trackingUpdateOrderList {
          orders,
        }
      }`, { params })
        .then((res) => {
          const { data = {} } = res || {};
          const { trackingUpdateOrderList = {} } = data || {};
          const { orders = [] } = trackingUpdateOrderList || {};

          commit('toggleLoading', false);
          return Promise.resolve(orders);
        })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/transactions-batch/store/actions.js